"use strict";
/**
 * LingoShade Domain Package
 * Shared business logic, models, and utilities
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SUPPORT_EMAIL = exports.listeningCoverage = exports.mergeListeningRanges = exports.isListeningRanges = exports.DICTATION_SCORING = exports.validateDictationSetup = exports.validateDictation = exports.legacyCheckDictation = exports.isSupportedLanguage = exports.SupportedLanguages = exports.getLanguageInfo = exports.getAllLanguagesInfo = void 0;
__exportStar(require("./types/students"), exports);
__exportStar(require("./constants/levels"), exports);
__exportStar(require("./constants/languages"), exports); // This exports getAllLanguagesInfo, getLanguageInfo, etc.
// Explicit re-export for Rollup compatibility
var languages_1 = require("./constants/languages");
Object.defineProperty(exports, "getAllLanguagesInfo", { enumerable: true, get: function () { return languages_1.getAllLanguagesInfo; } });
Object.defineProperty(exports, "getLanguageInfo", { enumerable: true, get: function () { return languages_1.getLanguageInfo; } });
Object.defineProperty(exports, "SupportedLanguages", { enumerable: true, get: function () { return languages_1.SupportedLanguages; } });
Object.defineProperty(exports, "isSupportedLanguage", { enumerable: true, get: function () { return languages_1.isSupportedLanguage; } });
__exportStar(require("./constants/textSizes"), exports);
__exportStar(require("./constants/difficulties"), exports);
__exportStar(require("./constants/audio"), exports);
// Models
__exportStar(require("./models/text"), exports);
__exportStar(require("./models/dictation"), exports);
__exportStar(require("./models/user"), exports);
__exportStar(require("./models/lesson"), exports);
__exportStar(require("./models/progress"), exports);
// Legacy Services (keep existing for compatibility)
__exportStar(require("./services/progressCalculator"), exports);
__exportStar(require("./services/textProcessing"), exports);
var dictationChecker_1 = require("./services/dictationChecker");
Object.defineProperty(exports, "legacyCheckDictation", { enumerable: true, get: function () { return dictationChecker_1.checkDictation; } });
// New Services
__exportStar(require("./services/textManagement"), exports);
__exportStar(require("./services/dictationService"), exports);
__exportStar(require("./services/userManagement"), exports);
// Utilities
__exportStar(require("./utils/textNormalization"), exports);
__exportStar(require("./utils/textTokenizer"), exports);
__exportStar(require("./utils/sentenceTimings"), exports);
__exportStar(require("./utils/timeFormatting"), exports);
__exportStar(require("./utils/accuracyCalculation"), exports);
__exportStar(require("./playback/highlightSync"), exports);
__exportStar(require("./time/clock"), exports);
// New Validation Rules
__exportStar(require("./rules/textValidation"), exports);
__exportStar(require("./rules/userValidation"), exports);
__exportStar(require("./rules/fieldValidation"), exports);
var dictationValidation_1 = require("./rules/dictationValidation");
Object.defineProperty(exports, "validateDictation", { enumerable: true, get: function () { return dictationValidation_1.checkDictation; } });
Object.defineProperty(exports, "validateDictationSetup", { enumerable: true, get: function () { return dictationValidation_1.validateDictation; } });
Object.defineProperty(exports, "DICTATION_SCORING", { enumerable: true, get: function () { return dictationValidation_1.DICTATION_SCORING; } });
var listeningCoverage_1 = require("./services/listeningCoverage");
Object.defineProperty(exports, "isListeningRanges", { enumerable: true, get: function () { return listeningCoverage_1.isListeningRanges; } });
Object.defineProperty(exports, "mergeListeningRanges", { enumerable: true, get: function () { return listeningCoverage_1.mergeListeningRanges; } });
Object.defineProperty(exports, "listeningCoverage", { enumerable: true, get: function () { return listeningCoverage_1.listeningCoverage; } });
var contactSettings_1 = require("./types/contactSettings");
Object.defineProperty(exports, "DEFAULT_SUPPORT_EMAIL", { enumerable: true, get: function () { return contactSettings_1.DEFAULT_SUPPORT_EMAIL; } });
__exportStar(require("./types/materials"), exports);
__exportStar(require("./rules/materialVolume"), exports);
//# sourceMappingURL=index.js.map